module.exports = __webpack_public_path__ + "img/banner3.d6be8607.jpg";